import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import HealthFileCard from './HealthFileCard';

export default function HealthFilesGrid({
  files,
  fieldOptions,
  request,
  onFileUpdate,
  onFileDelete,
  onPreview,
  emptyMessage,
  downloadMode,
  downloadSelected,
  onToggleDownloadSelect,
}) {
  if (files.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">{emptyMessage || 'No files match your filters.'}</Typography>
      </Paper>
    );
  }

  const cards = [];
  for (let i = 0; i < files.length; i += 1) {
    const file = files[i];
    cards.push(
      <Grid item xs={12} sm={6} key={file.id} sx={{ p: '10px' }}>
        <HealthFileCard
          file={file}
          fieldOptions={fieldOptions}
          request={request}
          onUpdate={onFileUpdate}
          onDelete={onFileDelete}
          onPreview={onPreview}
          downloadMode={downloadMode}
          downloadSelected={!!downloadSelected[file.id]}
          onToggleDownloadSelect={onToggleDownloadSelect}
        />
      </Grid>
    );
  }

  return (
    <Grid container spacing={0} sx={{ maxWidth: '100%' }}>
      {cards}
    </Grid>
  );
}
